import React from 'react';
import { getEntitySpec } from './entitySpec';

var generateSources = function generateSources(src, entity, ratio, actualWidthFactor, width, sizesHint) {
  var imageSpec = getEntitySpec(entity, ratio);
  var sizes = imageSpec.allowedSizes.map(function (size) {
    return "".concat(src.path).concat(size.width, "x").concat(size.height, ".$FILE_TYPE$ ").concat(size.width, "w");
  }).join(','); // generate fallback src of <img>-tag if sources not supported for file types webp, png and jpeg

  var fallbackSrc = src.path + imageSpec.allowedSizes[1].width + 'x' + imageSpec.allowedSizes[1].height + '.jpeg';
  var sources;

  if (src.svg && imageSpec.fileTypes.includes('svg')) {
    // overwrite fallback img for svg
    fallbackSrc = src.path + 'image.svg';
  } else {
    sources = imageSpec.fileTypes.map(function (fileType) {
      if (fileType !== 'svg') {
        var defaultSizesAttribute = actualWidthFactor ? "".concat(100 / actualWidthFactor, "vw") : width !== null && width !== void 0 ? width : '100vw';
        var sizesAttribute = sizesHint || defaultSizesAttribute; // generate sources for webp, png and jpeg

        var srcSet = sizes.replace(/\$FILE_TYPE\$/g, "".concat(fileType));
        return /*#__PURE__*/React.createElement("source", {
          key: fileType,
          srcSet: srcSet,
          type: "image/".concat(fileType),
          sizes: sizesAttribute
        });
      }
    });
  }

  var imageSizeAttributes = imageSpec.allowedSizes[1];
  return {
    sources: sources,
    fallbackSrc: fallbackSrc,
    imageSizeAttributes: imageSizeAttributes
  };
};

export { generateSources };
//# sourceMappingURL=ImageUtils.js.map